import React from "react";

function Footer() {
    return (
        <footer className="footer mt-5 py-3 bg-light text-black">
            <div className="container text-center">
                <p className="mb-0">Copyright © NetMall. All Rights Reserved.</p>
            </div>
        </footer>
    );
}

export default Footer;
